import { boolean, object, string } from 'yup'

import { requiredMessage } from 'directFlow/state/config/content'

import { validateEmail } from 'utils/email'

export const schema = object({
  email: string()
    .test('is-valid-email', (value, context) => {
      const { isValid, message } = validateEmail(value)
      return isValid || context.createError({ message: message ?? '' })
    })
    .required(requiredMessage),
  optedInToProductUpdates: boolean().optional(),
  optedInToNbNurture: boolean().optional(),
})
